import { useEffect, useState } from "react";
import "./QuestionExtender.css";
import { checkAnswer, getCorrectAnswer } from "../../../utils/questionTool";

import x2cellQuestionLogo from "../../../images/2xcellQuestionLogo.svg";
import { ReactComponent as EditImg } from "../../../images/edit.svg";
import { ReactComponent as DeleteImg } from "../../../images/delete.svg";

function QuestionChecker(props) {
  const [status, setStatus] = useState({
    attempted: false,
    correct: false,
    message: "",
  });

  function isAnswerCorrect() {
    const isCorrect = checkAnswer(
      props.type,
      props.correctAnswers,
      props.answers
    );

    if (!isCorrect) {
      const correctAnswer = getCorrectAnswer(
        props.type,
        props.correctAnswers,
        props.options
      );
      setStatus({
        attempted: true,
        correct: isCorrect,
        message: `Wrong Answer! Correct Answer is <u>${correctAnswer}<u>`,
      });
    } else {
      setStatus({
        attempted: true,
        correct: isCorrect,
        message: `Hurray Correct Answer`,
      });
    }
  }

  function reset() {
    props.reset();
    setStatus({
      attempted: false,
      correct: false,
      message: "",
    });
  }

  useEffect(() => {
    if (!status.attempted) return;
    if (window.MathJax) {
      window.MathJax.typesetClear();
      window.MathJax.typesetPromise().catch((err) =>
        alert("MathJax render error:", err.message)
      );
    }
  }, [status.attempted]);

  return (
    <div className="question-checker">
      <>{props.children}</>
      <div className="last">
        {props.isStaff ? (
          <div
            className={
              props.isPraticeSession
                ? "signarture ps_sign"
                : "signarture ot_sign"
            }
          >
            {props.staff?.name} <br />
            {props.staff.schoolName}
          </div>
        ) : (
          <div
            className={
              props.isPraticeSession
                ? "signarture ps_sign"
                : "signarture ot_sign"
            }
            style={{ fontSize: "30px", textAlign: "center" }}
          >
            <img className="imgLogo" src={x2cellQuestionLogo} />
          </div>
        )}

        <div className="icon_res">
          {props.isStaff && (
            <EditImg
              onClick={props.openEdit}
              className={props.isPraticeSession ? "ps_edit" : "ot_edit"}
            />
          )}
          {props.isStaff && (
            <DeleteImg
              onClick={props.delete}
              className={props.isPraticeSession ? "ps_delete" : "ot_delete"}
            />
          )}
          {props.isPraticeSession ? (
            status.attempted ? (
              <button
                className={`${
                  status.correct ? "correct" : "incorrect"
                } check-button`}
                onClick={reset}
              >
                Reset
              </button>
            ) : (
              <button className={`check-button`} onClick={isAnswerCorrect}>
                Check
              </button>
            )
          ) : null}
        </div>
      </div>

      <>
        {(status.attempted && props.correctAnswers?.explanation || !props.isPraticeSession && props.type==="assertion-reasoning") ? (
          <div className="explanation">
            <span>Explanation</span>
            <p dangerouslySetInnerHTML={{ __html: props.correctAnswers?.explanation || "" }}></p>
          </div>
        ) : null}
        <p
          style={{ opacity: status.attempted ? 1 : 0 }}
          dangerouslySetInnerHTML={{ __html: status.message }}
          className={`check-status ${status.correct ? "correct" : "incorrect"}`}
        ></p>
      </>
    </div>
  );
}
export default QuestionChecker;
